<template>
  <Modal>
    <Modal.Title>
      <span class="flex items-center gap-2.5">
        <span
          class="flex size-[30px] items-center justify-center rounded-full bg-red-200/50"
        >
          <AlertIcon class="size-4 text-red-700" />
        </span>
        Delete {{ copy.folder }}?
      </span>
    </Modal.Title>
    <Modal.Body>
      Are you sure you want to delete
      <span class="font-medium">{{ copy.folderName }}</span> from your Dacr
      account?
    </Modal.Body>
    <Modal.Footer>
      <Button
        :size="isMobile ? 'lg' : 'md'"
        :disabled="loading"
        @click="close()"
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        :loading="loading"
        @click="handleClick"
      >
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import { openModal, Modals } from '@/shared/dialogs/modals'
import { useDeleteFoldersMutation } from '@/shared/graphql/legacy/generated'
import type { Folder } from '@/shared/graphql/router/graphql'
import { removeItemsFromExplorerCache } from '@/features/explorer/utils/explorerCache'
import { useExplorerSelection } from '@/features/explorer/composables/useExplorerSelection'
import { useDevice } from '@/shared/composables/useDevice'

const { close, triggerEvent } = useModal()
const { isMobile } = useDevice()

const props = defineProps<{
  items: Folder[]
}>()

const { clear: clearSelection } = useExplorerSelection()

const { mutate: deleteFolder, loading } = useDeleteFoldersMutation()

const hasMultipleItems = props.items.length > 1

const copy = {
  folder: hasMultipleItems ? 'folders' : 'folder',
  folderName: hasMultipleItems
    ? `${props.items.length} folders`
    : props.items[0].name,
}

const handleClick = async () => {
  const idsToDelete = props.items.map((item) => item.id)

  try {
    await deleteFolder({
      folderIds: idsToDelete,
    })

    removeItemsFromExplorerCache(idsToDelete)
    clearSelection()

    triggerEvent('success')

    close()
  } catch (error) {
    if (error instanceof Error && error.message.includes('inside')) {
      openModal(Modals.CannotDeleteFolder)
    }
  }
}
</script>
